export const usePromotionDescriptionFor = ['PREMIUM9'];
